exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-result h3 {\n  margin: 0; }\n\n.search-result .result-link {\n  width: 100%;\n  margin-bottom: 10px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/github-search/github-search.component.scss
// module id = ./src/app/components/github-search/github-search.component.scss
// module chunks = main